import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DispatchContext from '../DispatchContext';
import NTPLogo from 'ntp-logo-react';

function Register() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [c_password, setCPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [registered, setRegistered] = useState(false);
    const dispatch = useContext(DispatchContext);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);

        if (!name || !email || !password || !c_password) {
            setError('Toate câmpurile sunt obligatorii');
            setLoading(false);
            return;
        }

        if (password !== c_password) {
            setError('Parolele nu se potrivesc');
            setLoading(false);
            return;
        }

        if (!/\S+@\S+\.\S+/.test(email)) {
            setError('Email invalid');
            setLoading(false);
            return;
        }

        try {
            const response = await fetch('https://backend.alephmedia.ro/api/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'include',
                body: JSON.stringify({ name, email, password, c_password })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Înregistrare eșuată');
            }

            const data = await response.json();
            setRegistered(true);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handlePayment = async (amount) => {
        const orderId = `order_${Math.random().toString(36).substr(2, 9)}`;
        const date = new Date();
        
        const paymentData = {
            order: {
                $: {
                    id: orderId,
                    timestamp: date.getTime(),
                    type: "card",
                },
                signature: "2VAQ-ODTK-QCP9-B2YN-W611",
                url: {
                    return: "https://alephmedia.ro/",
                    confirm: "https://backend.alephmedia.ro/api/payment/confirm",
                },
                invoice: {
                    $: {
                        currency: "EUR",
                        amount: amount.toString(),
                    },
                    details: "Plată abonament Aleph Media",
                    contact_info: {
                        billing: {
                            $: {
                                type: "person",
                            },
                            first_name: name.split(' ')[0] || name,
                            last_name: name.split(' ')[1] || name,
                            address: "N/A",
                            email: email,
                            mobile_phone: "N/A",
                        }
                    },
                },
                ipn_cipher: "aes-256-cbc",
            },
        };

        try {
            const response = await fetch('https://backend.alephmedia.ro/api/payment/initiate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(paymentData)
            });

            const data = await response.json();

            if (data.success && data.paymentData) {
                // Creăm formularul pentru plată
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = data.paymentData.url;

                const envKeyInput = document.createElement('input');
                envKeyInput.type = 'hidden';
                envKeyInput.name = 'env_key';
                envKeyInput.value = data.paymentData.env_key;
                form.appendChild(envKeyInput);

                const dataInput = document.createElement('input');
                dataInput.type = 'hidden';
                dataInput.name = 'data';
                dataInput.value = data.paymentData.data;
                form.appendChild(dataInput);

                const cipherInput = document.createElement('input');
                cipherInput.type = 'hidden';
                cipherInput.name = 'cipher';
                cipherInput.value = data.paymentData.cipher;
                form.appendChild(cipherInput);

                const ivInput = document.createElement('input');
                ivInput.type = 'hidden';
                ivInput.name = 'iv';
                ivInput.value = data.paymentData.iv;
                form.appendChild(ivInput);

                // Adăugăm un handler pentru răspunsul de la confirmare
                window.addEventListener('message', async (event) => {
                    if (event.origin === 'https://backend.alephmedia.ro') {
                        const response = event.data;
                        if (response.success) {
                            // Salvăm token-ul și datele utilizatorului
                            localStorage.setItem('authToken', response.data.token);
                            localStorage.setItem('userData', JSON.stringify({ name: response.data.name }));
                            
                            // Actualizăm starea aplicației
                            dispatch({ type: "userLoggedIn", payload: { name: response.data.name } });
                            
                            // Afișăm notificarea
                            dispatch({ 
                                type: "newEvent", 
                                value: {
                                    header: "Înregistrare reușită",
                                    message: "Vă mulțumim pentru înregistrare!",
                                    link: "/"
                                }
                            });
                            
                            // Redirecționăm către pagina principală
                            navigate('/');
                        }
                    }
                });

                document.body.appendChild(form);
                form.submit();
            } else {
                throw new Error(data.message || 'Eroare la inițierea plății');
            }
        } catch (error) {
            setError(error.message);
            setLoading(false);
        }
    };

    if (registered) {
        return (
            <div className="auth-wrapper">
                <div className="auth-container">
                    <h2 className="auth-title">Alegeți abonamentul</h2>
                    <div className="subscription-options">
                        <div className="subscription-option">
                            <h3>Abonament Basic</h3>
                            <ul>
                                <li>Acces la știrile de bază</li>
                                <li>Notificări importante</li>
                                <li>Conținut exclusiv limitat</li>
                            </ul>
                            <button 
                                onClick={() => handlePayment(5)} 
                                className="form-submit"
                                disabled={loading}
                            >
                                {loading ? 'Se procesează...' : 'Alege 5€'}
                            </button>
                        </div>
                        <div className="subscription-option">
                            <h3>Abonament Premium</h3>
                            <ul>
                                <li>Acces nelimitat la tot conținutul</li>
                                <li>Conținut exclusiv premium</li>
                                <li>Suport prioritar</li>
                            </ul>
                            <button 
                                onClick={() => handlePayment(10)} 
                                className="form-submit"
                                disabled={loading}
                            >
                                {loading ? 'Se procesează...' : 'Alege 10€'}
                            </button>
                        </div>
                    </div>
                    {error && <p className="error">{error}</p>}

                    {/* Payment section */}
                    <div className="payment-section">
                      <div className="payment-logos">
                        <div className="netopia-logo">
                          <NTPLogo color="#ffffff" version="orizontal" secret="150772" />
                        </div>
                        <div className="compliance-logos">
                          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">
                            <img src="/assets/img/anpc-sal.png" alt="Soluționarea Alternativă a Litigiilor" />
                          </a>
                          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                            <img src="/assets/img/eu-sol.png" alt="Soluționarea Online a Litigiilor" />
                          </a>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-wrapper">
            <div className="auth-container">
                <h1 className="auth-title">Înregistrare</h1>

                {error && <p className="error">{error}</p>}
                {loading && <p className="loading">Se procesează...</p>}

                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="form-field"
                            placeholder="Nume complet"
                            required
                        />
                    </div>
                    <div className="form-row">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-field"
                            placeholder="Email"
                            required
                        />
                    </div>
                    <div className="form-row">
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-field"
                            placeholder="Parolă"
                            required
                        />
                    </div>
                    <div className="form-row">
                        <input
                            type="password"
                            value={c_password}
                            onChange={(e) => setCPassword(e.target.value)}
                            className="form-field"
                            placeholder="Confirmare parolă"
                            required
                        />
                    </div>
                    <div className="form-row">
                        <button
                            type="submit"
                            className="form-submit"
                            disabled={loading}
                        >
                            {loading ? 'Se procesează...' : 'Înregistrare'}
                        </button>
                    </div>
                </form>

                <a href="/login" className="auth-link">
                    Aveți deja cont? Autentificați-vă
                </a>
            </div>
        </div>
    );
}

export default Register; 